function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M469.629,221.898c-23.446-41.595-73.545-60.12-118.412-43.785l-50.72-109.888H348c6.627,0,12,5.373,12,12s-5.373,12-12,12 h-4c-4.418,0-8,3.582-8,8s3.582,8,8,8h4c15.464,0,28-12.536,28-28s-12.536-28-28-28h-60c-4.418,0-8,3.582-8,8 c0,1.157,0.251,2.301,0.736,3.352l20.608,44.648h-125.88l-11-24h6.872c11.408,0.023,20.674-9.207,20.697-20.615 c0.021-10.563-7.931-19.44-18.433-20.577l-43.952-4.896c-12.689-1.383-24.097,7.783-25.479,20.473 c-1.383,12.689,7.783,24.097,20.473,25.479c0.823,0.09,1.651,0.135,2.479,0.136h19.744l13.496,29.448l-30.68,64.8 c-49.611-18.614-104.919,6.514-123.533,56.125s6.514,104.919,56.125,123.533s104.919-6.514,123.533-56.125 c3.109-8.286,5.056-16.962,5.787-25.781h17.544c4.322,17.091,21.681,27.442,38.771,23.12c17.091-4.322,27.442-21.68,23.12-38.771 c-1.663-6.576-5.377-12.45-10.604-16.773l52.416-110.664l23.84,51.664c-46.957,26.469-63.566,85.992-37.097,132.948 c26.469,46.957,85.992,63.566,132.948,37.097C479.488,328.378,496.097,268.855,469.629,221.898z M127.12,68.224 c-3.929,0-7.116-3.183-7.12-7.112c0.004-3.917,3.171-7.094,7.088-7.112c0.272,0,0.536,0,0.8,0.04l43.952,4.888 c2.558,0.3,4.389,2.618,4.088,5.176c-0.274,2.334-2.242,4.1-4.592,4.12H127.12z M137.256,199.816 c21.572,12.982,35.775,35.361,38.336,60.408H108.64L137.256,199.816z M96,348.224c-44.183,0.145-80.117-35.554-80.263-79.736 c-0.145-44.182,35.554-80.117,79.736-80.263c9.317-0.031,18.567,1.566,27.335,4.719L88.8,264.8 c-1.891,3.993-0.187,8.763,3.806,10.654c1.061,0.503,2.22,0.765,3.394,0.77h79.592C171.441,317.079,137.065,348.176,96,348.224z M209.136,260.224h-17.544c-2.642-31.224-20.357-59.194-47.456-74.928l24.928-52.632l50.824,110.88 C214.621,247.819,210.854,253.662,209.136,260.224z M240,284.224c-8.837,0-16-7.163-16-16s7.163-16,16-16s16,7.163,16,16 S248.837,284.224,240,284.224z M246.016,236.84c-1.981-0.397-3.996-0.603-6.016-0.616c-1.88,0.027-3.753,0.217-5.6,0.568 l-51.6-112.568h116.56L246.016,236.84z M384.664,348.831c-44.35,0.183-80.452-35.621-80.635-79.971 c-0.118-28.495,14.874-54.919,39.395-69.435l33.312,72.168c1.77,4.048,6.486,5.896,10.535,4.126 c4.048-1.77,5.896-6.486,4.126-10.534c-0.042-0.097-0.086-0.193-0.133-0.287l-33.328-72.208 c8.378-2.933,17.188-4.442,26.064-4.464c44.35-0.183,80.452,35.621,80.635,79.971 C464.819,312.546,429.014,348.648,384.664,348.831z"
})));

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("polygon", {
  points: "384,364.224 96,364.224 0,364.224 0,380.224 480,380.224 480,364.224 \t\t"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M112,428.224H16c-4.418,0-8,3.582-8,8s3.582,8,8,8h96c4.418,0,8-3.582,8-8S116.418,428.224,112,428.224z"
})));

var _ref4 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M296,428.224H184c-4.418,0-8,3.582-8,8s3.582,8,8,8h112c4.418,0,8-3.582,8-8S300.418,428.224,296,428.224z"
})));

var _ref5 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M464,428.224h-96c-4.418,0-8,3.582-8,8s3.582,8,8,8h96c4.418,0,8-3.582,8-8S468.418,428.224,464,428.224z"
})));

var _ref6 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M96,316.224c-4.645,0.006-9.267-0.662-13.72-1.984c-4.226-1.29-8.697,1.09-9.987,5.316s1.09,8.697,5.316,9.987 c0.037,0.011,0.074,0.022,0.112,0.033c5.933,1.762,12.091,2.654,18.28,2.648c4.418,0,8-3.582,8-8S100.418,316.224,96,316.224z"
})));

var _ref7 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M62.4,302.512c-9.248-9.006-14.444-21.38-14.4-34.288c-0.002-4.646,0.669-9.267,1.992-13.72 c1.259-4.237-1.155-8.693-5.392-9.952c-4.237-1.259-8.693,1.155-9.952,5.392c-6.75,22.754-0.38,47.376,16.56,64 c1.495,1.461,3.502,2.28,5.592,2.28c4.418-0.001,8-3.583,7.999-8.001C64.799,306.075,63.934,304.017,62.4,302.512z"
})));

var _ref8 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M411.44,210.416c-5.787-2.755-11.959-4.616-18.304-5.52c-4.376-0.623-8.429,2.42-9.052,6.796 c-0.623,4.376,2.42,8.429,6.796,9.052c4.748,0.672,9.366,2.061,13.696,4.12c1.071,0.503,2.241,0.759,3.424,0.752 c4.418-0.026,7.979-3.628,7.953-8.047C415.935,214.52,414.185,211.746,411.44,210.416z"
})));

var _ref9 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M436.544,231.648c-2.601-3.571-7.605-4.358-11.177-1.757c-3.469,2.526-4.326,7.34-1.943,10.909 c5.608,8.043,8.603,17.619,8.576,27.424c0.002,4.645-0.667,9.266-1.984,13.72c-1.257,4.232,1.153,8.683,5.384,9.944 c0.739,0.224,1.508,0.338,2.28,0.336c3.539-0.002,6.656-2.328,7.664-5.72C450.902,267.832,447.664,247.645,436.544,231.648z"
})));

var _ref10 =
/*#__PURE__*/
React.createElement("g", null);

var _ref11 =
/*#__PURE__*/
React.createElement("g", null);

var _ref12 =
/*#__PURE__*/
React.createElement("g", null);

var _ref13 =
/*#__PURE__*/
React.createElement("g", null);

var _ref14 =
/*#__PURE__*/
React.createElement("g", null);

var _ref15 =
/*#__PURE__*/
React.createElement("g", null);

var _ref16 =
/*#__PURE__*/
React.createElement("g", null);

var _ref17 =
/*#__PURE__*/
React.createElement("g", null);

var _ref18 =
/*#__PURE__*/
React.createElement("g", null);

var _ref19 =
/*#__PURE__*/
React.createElement("g", null);

var _ref20 =
/*#__PURE__*/
React.createElement("g", null);

var _ref21 =
/*#__PURE__*/
React.createElement("g", null);

var _ref22 =
/*#__PURE__*/
React.createElement("g", null);

var _ref23 =
/*#__PURE__*/
React.createElement("g", null);

var _ref24 =
/*#__PURE__*/
React.createElement("g", null);

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    version: 1.1,
    id: "Capa_1",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 482.223 482.223",
    style: {
      "enableBackground": "new 0 0 482.223 482.223"
    },
    xmlSpace: "preserve"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24);
};

export default __webpack_public_path__ + "static/media/bicycle.cf9ea8e2.svg";
export { SvgComponent as ReactComponent };